
export class SearchFilters {
    public customer: number[] = [];
    public jobsite: number[] = [];
    public equipment: number[] = [];
    public make: number[] = [];
    public model: number[] = [];
    public implement: number[] = [];
    public ImplementTypes:number[]=[];
    public ComponentTypes:number[]=[];
    public evalA: boolean = true;
    public evalB: boolean = true;
    public evalC: boolean = true;
    public evalX: boolean = true;
    public onEq: number;
    public NoImps:boolean=false;
    public family: number[] = [];
    public assetSerial:number[]=[];
    public GETType:number[]=[];
    public makeUC: number[] = [];
    public PageNumber: number
    public PageSize: number;
    public sortName?: string;
    public sortOrder?: string;
    public GETId? : number;
    public Level?: number = 1; // 1=Equipment, 2=ComponentType, 3=Component
    public UnitNo?: string | null;
    public ComponentType?: string | null;
    public Months?: number;
}

export class implementforDashboard {
    public  GET_auto:number[] = [];
}
